// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pie-block {
  width: 40px;
  height: 40px;
  color: var(--colorTextInverse);
}
.pie-block text {
  width: 20px;
  height: 20px;
  background: var(--colorBgLevel2);
  color: var(--colorText);
  font-size: 11px;
}
.pie-block svg {
  width: 40px;
  height: 40px;
}

.row-tooltip {
  display: flex;
  margin-bottom: 1px;
}
.row-tooltip div {
  display: flex;
  align-items: center;
}
.row-tooltip div:nth-child(1) {
  width: 70%;
  text-align: left;
  font-size: 12px;
  line-height: 14px;
}
.row-tooltip div:nth-child(1).badge {
  width: auto;
}
.row-tooltip div:nth-child(2) {
  width: 30%;
  text-align: right;
  font-size: 12px;
  line-height: 14px;
  justify-content: flex-end;
}
.row-tooltip .title {
  margin-bottom: 8px;
  font-weight: bold;
  align-items: flex-start;
}

.tooltip-container {
  padding: 8px;
  width: 268px;
}
.tooltip-container .title-tooltip {
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 25px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tooltip-container .info-tooltip {
  font-size: 14px;
  line-height: 19px;
  text-align: left;
  margin-bottom: 8px;
}

.badge {
  padding: 4px;
  height: 22px;
  background: #888;
  border-radius: 3px;
  color: var(--colorTextInverse);
  display: inline-block;
}
.badge.falsevalue {
  background: var(--colorFalseValue);
}
.badge.success {
  background: var(--colorSuccess);
}
.badge.warning {
  background: var(--colorWarning);
}
.badge.error {
  background: var(--colorError);
}
.badge.none {
  background: var(--colorNoControl);
}
.badge.critical {
  background: var(--colorCritical);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
